<div class="loading-cont" [ngClass]="styling"  [hidden]="!showLoader">

  <div class="loading-items-cont">

    <div [hidden]="!loadingComplete">
      <div class="spinner-cont">
        <mat-icon style="font-size: 60px; color: #70ae6e;">check_circle</mat-icon>
        <!-- <fa-icon [icon]="['far', 'check-circle']" style="font-size: 60px; color: #70ae6e; "></fa-icon> -->
      </div>
      <div class="text-cont">Update Complete</div>
    </div>

    <div [hidden]="loadingComplete" >
      <div style="display: flex; align-items: center; " [ngStyle]="{'flex-direction': flexDirection}" [ngClass]="{'text-position-right': (textPosition == 'RIGHT') }">
        <div class="spinner-cont" [ngStyle]="{ 'width.px': spinnerDiameter}" style="box-sizing: content-box;">
          <mat-spinner [diameter]="spinnerDiameter" [strokeWidth]="spinnerStrokeWidth"></mat-spinner>
        </div>

        <div class="text-cont" [ngStyle]="{'text-align': (textPosition == 'BOTTOM' ? 'center' : 'left' ) }">
          {{ message || 'Loading...' }}
        </div>
        @if (textPosition == 'BOTTOM') {
          <div class="text-cont">
            {{ progressMessage }}
          </div>
        }

      </div>
    </div>

  </div>
</div>

